/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-07-06",
    versionChannel: "nightly",
    buildDate: "2023-07-06T00:19:35.004Z",
    commitHash: "009fab1889fe737c6dfafc5bca0ebaef927b8cd4",
};
